import { ChevronLeftCircle, ChevronRightCircle } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PanduanAplikasi() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [filter, setFilter] = useState('all');
  const [panduan, setPanduan] = useState([]);
  const [selectedPanduan, setSelectedPanduan] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchPanduan = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/panduan`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setPanduan(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchPanduan();
  }, []);

  const steps = selectedPanduan
  ? Array.from({ length: 10 }, (_, i) => ({
      step: selectedPanduan[`step${i + 1}`],
      image: selectedPanduan[`image${i + 1}`],
    })).filter((item) => item.step && item.image)
  : [];

  const [sectionHero, setSectionHero] = useState({
    title: "",
    page: "",
    description: "",
    image: "", 
  });

  const fetchSectionHero = async () => {
      
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/sectionhero/panduanAplikasi`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setSectionHero(json.data[0] || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };
  
  useEffect(() => {
    fetchSectionHero();
  }, []);  


  return (
    <div className="min-h-screen bg-slate-400/95  text-white  pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-white"
      >
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-white"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>        

        <div className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}>
          <h1 className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-red-400 via-white to-blue-800
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]">
            {sectionHero.page}
          </h1>
          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>
          <p className="text-xl mx-auto
            max-w-xs sm:max-w-2xl text-white
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]">
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Filter Section */}
      {/* <section 
        data-section="filter"
        className="py-8 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('filter') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg shadow-blue-500/50'
                    : 'bg-slate-800 text-gray-400 hover:text-white hover:bg-slate-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-16 bg-white"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          {Array.isArray(panduan) && panduan.map((a, idx) => (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl bg-slate-800/50 border border-slate-700 hover:border-blue-500/50 transition-all duration-500 transform hover:scale-105"
                style={{ 
                  transitionDelay: `${1 * 100}ms`,
                  animation: 'fadeIn 0.5s ease-out'
                }}
              >
                <div className={`aspect-video bg-gradient-to-r from-red-500 to-[#3E3274] relative overflow-hidden`}>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.image1}`}
                        alt=""
                        className="h-full object-contain"
                      />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button 
                    onClick={() => {
                      setSelectedPanduan(a);
                      setCurrentIndex(0);
                    }}
                    className="px-6 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300">
                      Lihat Panduan
                    </button>
                  </div>
                </div>
                
                <div className="p-6 bg-slate-100/90">
                  <h3 className="text-xl font-bold mb-2 text-slate-700 group-hover:text-[#3E3274] transition-colors duration-300">
                    {a.title}
                  </h3>
                </div>
              </div>              
            </div>            
            ))
          }
        </div>
      </section>

      {/* CTA Section */}
      <section 
        data-section="cta"
        className="py-24 bg-white relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-500/20 rounded-full blur-3xl"></div>
        </div>

        <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent leading-tight">
            Ayo bergabung menjadi mitra Kami!
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-slate-700 mb-6 md:mb-8 leading-relaxed">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>
          <Link 
            to="https://play.google.com/store/apps/details?id=com.otoreport.kenziekomunika" target="_blank"
            className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300 text-white"
          >
            Mulai mendaftar
          </Link>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      {selectedPanduan && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">

          {/* Glass Background */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-xl"
            onClick={() => setSelectedPanduan(null)}
          />

          {/* Modal Content */}
          <div className="relative
              w-[95%] sm:w-[90%] md:w-[80%] lg:w-[40%]
              h-[88vh] md:h-[90vh]
              bg-white/10 backdrop-blur-2xl
              border border-white/20
              rounded-2xl overflow-hidden shadow-2xl">

            {/* Close Button */}
            <button
              onClick={() => setSelectedPanduan(null)}
              className="absolute top-3 right-3
                md:top-4 md:right-4
                z-50
                text-white
                text-xl md:text-2xl"
            >
              ✕
            </button>

            {/* Slider Content */}
            <div className="relative w-full h-full flex items-center justify-center overflow-hidden">

              {/* Slide */}
              <div
                className="w-full h-full flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`
                }}
              >
                {steps.map((item, index) => (
                  <div
                    key={index}
                    className="w-full h-full flex-shrink-0
                      flex flex-col items-center justify-center
                      gap-2 sm:gap-4
                      px-4 sm:px-8 md:px-12
                      pt-14 sm:pt-16 md:pt-20
                      pb-6"
                  >
                    <span className="text-sm sm:text-base md:text-lg
                        font-semibold
                        text-center
                        leading-relaxed
                        max-w-[92%] sm:max-w-[80%]">{item.step}</span>

                    <img
                      src={`${process.env.REACT_APP_BASE_URL}uploads/images/${item.image}`}
                      alt=""
                      className="object-contain
                        h-[65%]
                        sm:h-[70%]
                        md:h-[75%]"
                    />
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === 0 ? steps.length - 1 : prev - 1
                  )
                }
                className="absolute left-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronLeftCircle size={48} className="w-10 h-10 md:w-14 md:h-14"/>
              </button>

              <button
                onClick={() =>
                  setCurrentIndex((prev) =>
                    prev === steps.length - 1 ? 0 : prev + 1
                  )
                }
                className="absolute right-4 text-white text-3xl transform hover:scale-125 duration-500"
              >
                <ChevronRightCircle size={48} className="w-10 h-10 md:w-14 md:h-14"/>
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
    
  );
}
